import { Deposit } from "@/models/base/deposit";
import { ConfirmResult } from "winfakt-vue-components";

export class SaleEditStateCreatedDeposits{
	deposits:Deposit[] = [];
	modalCallback:((result:ConfirmResult)=>void) | null = null;

	public async showModal(deposits:Deposit[]):Promise<ConfirmResult>{
		if (this.modalCallback) return ConfirmResult.NO;
		this.deposits = deposits;
		let result:ConfirmResult = await new Promise((resolve)=>{
			this.modalCallback = resolve;
		});
		this.deposits = [];
		this.modalCallback = null;
		return result;
	}
}